import { useNavigate } from 'react-router-dom';
import { impactOccuer } from '../utils/hapticEvents';

type RowWithIconProps = {
  title: string;
  icon: React.ReactNode;
  navigateRoute?: string;
  /** Не переход, а действие на месте — например, открыть шторку. */
  onClick?: () => void;
};

export const RowWithIcon = ({
  title,
  icon,
  navigateRoute,
  onClick,
}: RowWithIconProps) => {
  const navigate = useNavigate();
  return (
    <div
      className="w-full flex flex-row space-x-3 items-center"
      onClick={() => {
        if (onClick) {
          onClick();
        } else if (navigateRoute) {
          navigate(navigateRoute);
        }
        impactOccuer('light');
      }}
    >
      <div className="w-10 h-10 bg-background rounded-[10px] flex items-center justify-center">
        {icon}
      </div>
      <p className="text-body-base-regular font-inter">{title}</p>
    </div>
  );
};
